const SET_ESP32_UPLOAD_PHASE = 'scratch-gui/esp32-upload/SET_PHASE';
const SET_ESP32_UPLOAD_TEXT = 'scratch-gui/esp32-upload/SET_TEXT';
const APPEND_ESP32_UPLOAD_TEXT = 'scratch-gui/esp32-upload/APPEND_TEXT';
const SET_ESP32_ABORT_ENABLED = 'scratch-gui/esp32-upload/SET_ABORT_ENABLED';
const RESET_ESP32_UPLOAD = 'scratch-gui/esp32-upload/RESET';

const PHASES = {
    uploading: 'uploading',
    success: 'success',
    error: 'error'
};

const initialState = {
    phase: PHASES.uploading,
    text: '',
    abortEnabled: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_ESP32_UPLOAD_PHASE:
        return Object.assign({}, state, {
            phase: action.phase
        });
    case SET_ESP32_UPLOAD_TEXT:
        return Object.assign({}, state, {
            text: action.text
        });
    case APPEND_ESP32_UPLOAD_TEXT:
        return Object.assign({}, state, {
            text: state.text + action.text
        });
    case SET_ESP32_ABORT_ENABLED:
        return Object.assign({}, state, {
            abortEnabled: action.abortEnabled
        });
    case RESET_ESP32_UPLOAD:
        return initialState;
    default:
        return state;
    }
};

const setEsp32UploadPhase = function (phase) {
    return {
        type: SET_ESP32_UPLOAD_PHASE,
        phase: phase
    };
};

const setEsp32UploadText = function (text) {
    return {
        type: SET_ESP32_UPLOAD_TEXT,
        text: text
    };
};

const appendEsp32UploadText = function (text) {
    return {
        type: APPEND_ESP32_UPLOAD_TEXT,
        text: text
    };
};

const setEsp32AbortEnabled = function (abortEnabled) {
    return {
        type: SET_ESP32_ABORT_ENABLED,
        abortEnabled: abortEnabled
    };
};

const resetEsp32Upload = function () {
    return {
        type: RESET_ESP32_UPLOAD
    };
};

export {
    reducer as default,
    initialState as esp32UploadInitialState,
    PHASES as ESP32_UPLOAD_PHASES,
    setEsp32UploadPhase,
    setEsp32UploadText,
    appendEsp32UploadText,
    setEsp32AbortEnabled,
    resetEsp32Upload
};

